

export default {
    ...{
        //TODO: APP
        loading: state => {
            return state.app.loading
        },
        openModal: state => {
            return state.app.openModal
        },

        attrFilters: state => {
            const filters = {}
            const filterKeys = Object.keys(state.filters);
            for(let i = 0; i < filterKeys.length; i++) {
                if(filterKeys[i].indexOf('filter_') === 0) {
                    filters[filterKeys[i]] = state.filters[filterKeys[i]];
                }
            }
            return filters
        },
        attrFilterKeys: state => {
            const filters = []
            const filterKeys = Object.keys(state.filters);
            for(let i = 0; i < filterKeys.length; i++) {
                if(filterKeys[i].indexOf('filter_') === 0 && state.filters[filterKeys[i]]) {
                    filters.push(filterKeys[i]);
                }
            }
            return filters
        }
    }
}
